
import { Component, Vue } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { appTheme, applyTheme, getStoredTheme, setStoredTheme } from '../theme';
import { THEME_NAMES, ThemeName } from '../themes';

@Component
export default class ThemeSetting extends Vue {
  public selected: ThemeName = appTheme.name;

  public get email() {
    return readUserProfile(this.$store)?.email ?? '';
  }

  public get items() {
    return THEME_NAMES.map((name) => ({
      value: name,
      text: this.$t(name === 'sophia' ? 'settings.themeSophia' : 'settings.themeClassic'),
    }));
  }

  public created() {
    this.selected = getStoredTheme(this.email || undefined);
  }

  public onChange(name: ThemeName) {
    if (this.email) {
      setStoredTheme(this.email, name);
    }
    applyTheme(name);
  }
}
